module.exports = __webpack_public_path__ + "static/hit_2-062a75999eb2c4e82ddb7c07d46df5fe.png";